import script from "./BrandModalSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandModalSlide.vue?vue&type=script&setup=true&lang=js"

import "./BrandModalSlide.vue?vue&type=style&index=0&id=23cfe10b&lang=scss"

const __exports__ = script;

export default __exports__